import React from 'react';
import { AlertCircle } from 'lucide-react';

const CHUNK_RELOAD_KEY = '__chunk_reload_attempt__';

function isChunkLoadError(error) {
  if (!error) return false;
  const msg = String(error.message || '');
  const name = String(error.name || '');
  return name === 'ChunkLoadError' || /Loading chunk [\w-]+ failed/i.test(msg) || /Loading CSS chunk [\w-]+ failed/i.test(msg);
}

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { hasError: false, error: null }; }
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info);
    if (isChunkLoadError(error)) {
      const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
      if (Date.now() - last > 10000) {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
        window.location.reload();
      }
    }
  }
  render() {
    if (this.state.hasError) {
      const chunkErr = isChunkLoadError(this.state.error);
      if (chunkErr) {
        return (
          <div style={{ textAlign: 'center', padding: 60, color: '#888' }}>
            <AlertCircle size={48} style={{ color: '#ef4444', marginBottom: 16 }} />
            <h2 style={{ color: '#ef4444', fontSize: 20, marginBottom: 8 }}>A new version is available</h2>
            <p style={{ fontSize: 13, marginBottom: 20 }}>Please reload to get the latest version.</p>
            <button onClick={() => { sessionStorage.removeItem(CHUNK_RELOAD_KEY); window.location.reload(); }}
              style={{ padding: '10px 24px', background: '#ffd700', color: '#000', border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>
              Reload Page
            </button>
          </div>
        );
      }
      return (
        <div style={{ textAlign: 'center', padding: 60, color: '#888' }}>
          <AlertCircle size={48} style={{ color: '#ef4444', marginBottom: 16 }} />
          <h2 style={{ color: '#ef4444', fontSize: 20, marginBottom: 8 }}>Something went wrong</h2>
          <p style={{ fontSize: 13, marginBottom: 20 }}>{this.state.error?.message || 'An unexpected error occurred'}</p>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
            <button onClick={() => this.setState({ hasError: false, error: null })}
              style={{ padding: '10px 24px', background: '#1a1a2e', color: '#ffd700', border: '1px solid #ffd70040', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>
              Try Again
            </button>
            <button onClick={() => window.location.reload()}
              style={{ padding: '10px 24px', background: '#ffd700', color: '#000', border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
